import _assign from 'lodash/assign';
import _defaultsDeep from 'lodash/defaultsDeep';
import { Theme, builderEnvironment } from '@portal/builder';
import { ApiEndpoints } from '../environments/evironment.interface';
import { RunTimeConfig } from './run-time-config.interface';

export async function getRuntimeConfig(): Promise<RunTimeConfig> {
  const runtimeConfig = await fetch('assets/run-time-config/runTimeConfig.json');

  return runtimeConfig.json() as Promise<RunTimeConfig>;
}

function validateAndFixConfig(config: RunTimeConfig): void {
  // validate theme
  if (!Object.values(Theme).includes(config.builderEnvironment.theme)) {
    config.builderEnvironment.theme = Theme.DEFAULT;
  }
}

export function setRunTimeConfig(config: RunTimeConfig, endpoints: ApiEndpoints) {
  validateAndFixConfig(config);

  _assign(endpoints, _defaultsDeep(config.endpoints, endpoints));
  _assign(builderEnvironment, _defaultsDeep(config.builderEnvironment, builderEnvironment));
}
